export var EmitterEvent;
(function (EmitterEvent) {
    EmitterEvent["AgentCreated"] = "agent:created";
    EmitterEvent["AgentUpdated"] = "agent:updated";
    EmitterEvent["AgentReady"] = "agent:ready";
    EmitterEvent["AgentMessageProcess"] = "agent:message:process";
    EmitterEvent["UserCreated"] = "user:created";
    EmitterEvent["ChatCreated"] = "chat:created";
    EmitterEvent["ChatUpdated"] = "chat:updated";
    EmitterEvent["PersonalChatCreated"] = "personalChat:created";
    EmitterEvent["ChatMembershipCreated"] = "chatMembership:created";
    EmitterEvent["ChatMembershipUpdated"] = "chatMembership:updated";
    EmitterEvent["MessageCreated"] = "message:created";
    EmitterEvent["BrandKitUpdated"] = "brandKit:updated";
    EmitterEvent["CreativeEdited"] = "creative:edited";
    EmitterEvent["OAuthTokenStale"] = "oauth:token:stale";
    EmitterEvent["IntegrationConnected"] = "integration:connected";
    EmitterEvent["UserIntegrationsPurged"] = "user:integrations:purged";
})(EmitterEvent || (EmitterEvent = {}));
//# sourceMappingURL=emitter-event.const.js.map